import { LABELS } from '../constants';
import TrendLineChart, { TrendSeries, TrendStats, StatCardConfig } from './TrendLineChart';

interface TrendByProgramProps {
  series: TrendSeries[];
  stats: TrendStats;
  isLoading: boolean;
  type?: string;
}

const formatDuration = (seconds: number): string => {
  if (!seconds || isNaN(seconds)) return '-';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);
  if (h > 0) return `${h}h ${m}m`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
};

const TrendByProgram = ({ series, stats, isLoading, type }: TrendByProgramProps) => {
  const trend = stats?.avgTrend;
  const label = LABELS[type ?? ''] || type || "Alerts"
  const cards: StatCardConfig[] = [
    {
      label: `Total ${label}`,
      value: (stats?.totalAlerts ?? 0).toLocaleString('en-US'),
      subtitle: stats?.totalSubtitle,
      trend: stats?.totalTrend,
      tooltip: 'Total alerts in the selected period',
    },
    {
      label: 'Peak Program',
      value: stats?.topProgram ?? '-',
      subtitle: stats?.topSubtitle,
      tooltip: 'Program with the most alerts',
    },
    {
      label: 'Trend',
      value: '',
      arrowOnly: true,
      trend,
      subtitle:
        trend === 'up'
          ? 'Increasing'
          : trend === 'down'
            ? 'Decreasing'
            : 'Stable',
      tooltip: 'Overall trend direction',
    }
  ];

  return (
    <TrendLineChart
      title={`Trends by Program - ${label}`}
      series={series}
      stats={stats}
      isLoading={isLoading}
      topLabel="Top Program"
      topValue={stats?.topProgram ?? '-'}
      cards={cards}
    />
  );
};

export default TrendByProgram;
